import script from "./LeftMenuSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeftMenuSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./LeftMenuSidebar.vue?vue&type=style&index=0&id=38454652&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38454652"]])

export default __exports__